import 'core-js/stable';
import 'regenerator-runtime/runtime';
import {StrictMode} from 'react'; // 注入全局枚举 (必须在最前面)
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider, App as AntdApp} from 'antd';
import zhCN from 'antd/locale/zh_CN';
import '@/globals';
import darkTheme from '@/styles/antd-theme';
import {rootStore} from '@/stores';
import {MigrationModal} from '@/modules/MigrationModules';
import UpgradeNoticeModal from '@/components/UpgradeNoticeModal';
import '@/styles';
import App from './App';
import styles from './App/index.module.less';

const main = () => {
    const container = document.body.appendChild(document.createElement('div'));
    const root = createRoot(container);

    root.render(
        <StrictMode>
            <ConfigProvider
                theme={darkTheme}
                locale={zhCN}
                button={{autoInsertSpace: false}}
                wave={{disabled: true}}
            >
                <AntdApp
                    message={{
                        // 自定义 className
                        className: styles.customMessage,
                        // 最大显示数量
                        maxCount: 1
                    }}
                >
                    <BrowserRouter>
                        <App />
                        {/* 迁移提示弹窗挂在路由外层，避免页面 loading / 路由跳转把它卸载 */}
                        <MigrationModal userStore={rootStore.userStore} />
                        {/* V2.5 升级弹窗（普通公告 / Pro 老用户确认），同样挂在路由外层 */}
                        <UpgradeNoticeModal userStore={rootStore.userStore} />
                    </BrowserRouter>
                </AntdApp>
            </ConfigProvider>
        </StrictMode>
    );
};

main();
